export default __webpack_public_path__ + "static/media/3_col_11.2fca5182.jpg";